import {useSelector} from "react-redux";
import {
    BBBreachRiskSubscriptionBadge,
    BBDisableChildren, bbDoesUserHaveAccessToBreachRiskLevelForEntity,
    bbFindEntityWithinPortfolioOrSelf,
    isCurrentUserMemberOf
} from "../../../util/bbHelpers";
import React from "react";
import {Box} from "@material-ui/core";

const PremiumCustomersOnlyWrapper = ({children, portfolioView=false})=>{


    const {customers, customerInView} = useSelector(({customer}) => customer);
    const {portfolios, entityInView} = useSelector(({breachrisk}) => breachrisk);
    const {authUser} = useSelector(({auth}) => auth);

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    const isStaffAdmin = isCurrentUserMemberOf(authUser, "admin") || isCurrentUserMemberOf(authUser, "staff");


    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);

    const brSubscriptionRequired = "Premium";
    const overrideEnabledForAdminsStaff = false;
    const hasAccessLevel = portfolioView ? bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel4", entityInView)
        : bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel3", entityInView);;
    const isCorrectSubscriptionLevel = portfolioView
        ? hasAccessLevel
        : myEntity && myEntity.active_subscription && myEntity.premium_subscription && hasAccessLevel;

    return(
        <Box className={"m-0 p-0"} style={{position: "relative", alignItems:"center"}}>

            <BBDisableChildren
                // brLevelRequired={portfolioView ? null : "infoLevel4"}
                isDisabled={myEntity && brSubscriptionRequired ? (overrideEnabledForAdminsStaff && isStaffAdmin) ? true : isCorrectSubscriptionLevel : true}
                brSubscriptionRequired = {"Premium"}
            >
                {/*<div style={{right:"1%", top:"1%", position: "absolute", zIndex: 1}}>*/}
                {/*    <BBBreachRiskSubscriptionBadge subscriptionLevel={"Premium"} />*/}
                {/*</div>*/}
                {children}
            </BBDisableChildren>

        </Box>
    )
}

export default PremiumCustomersOnlyWrapper;
